export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-12 pb-6">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-2xl">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 rounded-full bg-secondary/10 text-secondary-foreground/90 px-3 py-1 text-xs font-semibold tracking-wider uppercase mb-3">
              <span className="h-1.5 w-1.5 rounded-full bg-secondary" />
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-foreground text-balance">
            {title}
          </h1>
          {description && (
            <p className="mt-3 text-base sm:text-lg text-muted-foreground leading-relaxed">
              {description}
            </p>
          )}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
    </div>
  );
}
